export default __webpack_public_path__ + "static/BundesSans-Web-Regular-56033129a6c160fb0dc0f1479d8d0f63.woff";